<template>
  <div :class="status === 'error' ? 'mt-3 mb-3' : ''">
    <img
      :src="app.getUrl(imgSrc)"
      alt=""
      class="w-100 h-auto mt-1 mb-1"
      :style="status === 'error' ? 'width: 30% !important;' : ''"
      :class="status === 'loading' ? 'd-none' : ''"
      style="
        pointer-events: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      "
      @load="onLoad"
      @error="onError"
    />
    <div v-if="status === 'loading'" class="w-100 h-auto mt-1 mb-1 d-table">
      <div class="scc-loader-content mx-auto">
        <div class="scc-loader-icon"></div>
        <div class="scc-loader-text font-weight-bold" style="color: #29d">
          영상 불러오는중...
        </div>
      </div>
    </div>
    <div
      v-if="status === 'error'"
      class="font-weight-bold txt-color-orange mt-2"
    >
      영상을 불러올 수 없습니다
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "RealTimeVideo",
  props: {
    src: "",
  },
  data() {
    return {
      app: store.state.app,
      status: "loading",
      imgSrc: "",
      errorImgUrl: "/img/warning.png",
    };
  },
  created() {
    this.status = "loading";
    this.imgSrc = this.src;
  },
  methods: {
    onLoad(e) {
      if (this.imgSrc !== this.errorImgUrl) {
        this.status = "loaded";
      }
    },
    onError(e) {
      this.status = "error";
      this.imgSrc = this.errorImgUrl;
    },
  },
};
</script>
